import React from 'react';
import Home from './components/pages/Home';
import Developers from './components/pages/Developers';
import Login from './components/pages/Login';
import Error from './components/pages/Error';
import Users from './components/pages/Users';
import User from './components/pages/User';
import Facilities from './components/pages/Facilities';
import Facility from './components/pages/Facility';
import FacilityAdd from './components/pages/FacilityAdd';
import Provider from './components/pages/Provider';
import Providers from './components/pages/Providers';
import ProviderAdd from './components/pages/ProviderAdd';
import Subscriptions from './components/pages/Subscriptions';
import Subscription from './components/pages/Subscription';
import Transactions from './components/pages/Transactions';
import Transaction from './components/pages/Transaction';
import Purchase from './components/pages/Purchase';
import Products from './components/pages/Products';
import ProductGroup from './components/pages/ProductGroup';
import ProductGroupAdd from './components/pages/ProductGroupAdd';
import ProductGroups from './components/pages/ProductGroups';
import Participants from './components/pages/Participants';
import Participant from './components/pages/Participant';
import ParticipantAdd from './components/pages/ParticipantAdd';
import Purchases from './components/pages/Purchases';
import SalesReportNew from './components/pages/SalesReportNew';
import SalesReports from './components/pages/SalesReports';
import SalesReport from './components/pages/SalesReport';
import Reports from './components/pages/Reports';
import MarketingConsents from './components/pages/MarketingConsents';
import SeasonalCourt from './components/pages/SeasonalCourt';
import SeasonalCourtReport from './components/pages/SeasonalCourtReport';
import SeasonalCourts from './components/pages/SeasonalCourts';
import SeasonalCourtsOverview from './components/pages/SeasonalCourtsOverview';
import SeasonalCourtSlot from './components/pages/SeasonalCourtSlot';
import ConfirmationEmails from './components/pages/ConfirmationEmails';
import ConfirmationEmail from './components/pages/ConfirmationEmail';
import PaymentMethods from './components/pages/PaymentMethods';
import CreditCardDetails from './components/pages/PaymentMethod/CreditCardDetails';
import PaymentMethodUndefined from './components/pages/PaymentMethod/PaymentMethodUndefined';
import Integrations from './components/pages/Integrations';
import Signups from './components/pages/Signups';
import Signup from './components/pages/Signup';
import AutomatedBookingAgreements from './components/pages/AutomatedBookingAgreements';
import AutomatedBookingAgreement from './components/pages/AutomatedBookingAgreement';
import Areas from './components/pages/Areas';
import Area from './components/pages/Area';
import AreaAdd from './components/pages/AreaAdd';
import Crawlings from './components/pages/Crawlings';
import Crawling from './components/pages/Crawling';
import CrawlingAdd from './components/pages/CrawlingAdd';
import Activities from './components/pages/Activities';
import Activity from './components/pages/Activity';
import Checks from './components/pages/Checks';
import SeasonalCourtPurchases from './components/pages/SeasonalCourtPurchases';
import SeasonalCourtPurchase from './components/pages/SeasonalCourtPurchase';
import Overview from './components/pages/Overview';
import Resource from './components/pages/Resource';
import ResourceGroups from './components/pages/ResourceGroups';
import ResourceGroup from './components/pages/ResourceGroup';
import ResourceSplit from './components/pages/ResourceSplit';
import RelayRules from './components/pages/RelayRules';
import RelayRule from './components/pages/RelayRule';
import Lockers from './components/pages/Lockers';
import Locker from './components/pages/Locker';
import LockerCreate from './components/pages/LockerCreate';
import MasterCodes from './components/pages/MasterCodes';
import ProviderAdmin from './components/pages/ProviderAdmin';
import ProviderAdminDetails from './components/pages/ProviderAdminDetails';
import ExternalPurchaseAttempt from './components/pages/ExternalPurchaseAttempt';
import ExternalPurchase from './components/pages/ExternalPurchase';
import ExternalActivity from './components/pages/ExternalActivity';
import FacilityRedirects from './components/pages/FacilityRedirects';
import FacilityRedirect from './components/pages/FacilityRedirect';
import FacilityRedirectAdd from './components/pages/FacilityRedirectAdd';
import Proxies from './components/pages/Proxies';
import SeoTexts from './components/pages/SeoTexts';
import SeoTextAdd from './components/pages/SeoTextAdd';
import FacilityTexts from './components/pages/FacilityTexts';
import FacilityTextAdd from './components/pages/FacilityTextAdd';
import NonPartnerFacilities from './components/pages/NonPartnerFacilities';
import NonPartnerFacility from './components/pages/NonPartnerFacility';
import AmbassadorApplications from './components/pages/AmbassadorApplications';
import PlayPlayers from './components/pages/PlayPlayers';
import Play from './components/pages/Play';
import PlayEvents from './components/pages/PlayEvents';
import PlayEvent from './components/pages/PlayEvent';
import PlayEventSession from './components/pages/PlayEventSession';
import PlayGames from './components/pages/PlayGames';
import PlayGame from './components/pages/PlayGame';
import TransactionReport from './components/pages/TransactionReport';
import ClubhouseAdminClubhouses from './components/pages/Clubhouse/Clubhouses';
import ClubhouseAdminClubhouse from './components/pages/Clubhouse/Clubhouse';
import ClubhouseAdminWannas from './components/pages/Clubhouse/Wannas';
import ClubhouseAdminWanna from './components/pages/Clubhouse/Wanna';
import ClubhouseAdminMemberships from './components/pages/Clubhouse/Memberships';
import ClubhouseAdminPayments from './components/pages/Clubhouse/Payments';

import {
  BookingDetails,
  CreateBooking,
  ProductDetails
} from './components/pages/Product';

export default [
  {
    path: "/login",
    component: Login,

  },
  {
    path: "/facilities",
    component: Facilities,

  },
  {
    path: "/facility/:facilityId",
    component: Facility,

  },
  {
    path: "/facility/",
    component: FacilityAdd,

  },
  {
    path: "/users",
    component: Users,

  },
  {
    path: "/user/:userId",
    component: User,

  },
  {
    path: "/providers",
    component: Providers,

  },
  {
    path: "/provider/:providerId",
    component: Provider,

  },
  {
    path: "/provider/",
    component: ProviderAdd,

  },
  {
    path: "/subscriptions",
    component: Subscriptions,

  },
  {
    path: "/paymentmethods",
    component: PaymentMethods,

  },
  {
    path: "/paymentmethod/creditcard/:creditCardId",
    component: CreditCardDetails,

  },
  {
    path: "/paymentmethod/undefined/:paymentMethodId",
    component: PaymentMethodUndefined,

  },
  {
    path: "/products",
    component: Products,

  },
  {
    path: "/productGroup",
    component: ProductGroupAdd,

  },
  {
    path: "/productGroups",
    component: ProductGroups,

  },
  {
    path: "/participants",
    component: Participants,

  },
  {
    path: "/productGroup/:productGroupId",
    component: ProductGroup,

  },
  {
    path: "/purchases",
    component: Purchases,

  },
  {
    path: "/product/new",
    component: CreateBooking,

  },
  {
    path: "/product/:productId/integration",
    component: ProductDetails,

  },
  {
    path: "/product/:productId",
    component: ProductDetails,

  },
  {
    path: "/participant/:participantId",
    component: Participant,

  },
  {
    path: "/participant",
    component: ParticipantAdd,

  },
  {
    path: "/product/details/:bookingId/:subsection?",
    component: BookingDetails,

  },
  {
    path: '/resource/:id',
    component: Resource,

  },
  {
    path: '/resourceGroups',
    component: ResourceGroups,

  },
  {
    path: '/resourceGroup/:id',
    component: ResourceGroup,

  },
  {
    path: '/resourceSplit/:id',
    component: ResourceSplit,

  },
  {
    path: '/integrations',
    component: Integrations,

  },
  {
    path: "/signups",
    component: Signups,

  },
  {
    path: "/automated-booking-agreements",
    component: AutomatedBookingAgreements,

  },
  {
    path: "/automated-booking-agreement/:agreementId",
    component: AutomatedBookingAgreement,

  },
  {
    path: "/signup/:signupId",
    component: Signup,

  },
  {
    path: "/areas",
    component: Areas,

  },
  {
    path: "/area/:areaId/edit",
    component: AreaAdd,

  },
  {
    path: "/area/:areaId",
    component: Area,

  },
  {
    path: "/area",
    component: AreaAdd,

  },
  {
    path: "/facility-redirects",
    component: FacilityRedirects,

  },
  {
    path: "/facility-redirect/:redirectId/edit",
    component: FacilityRedirectAdd,

  },
  {
    path: "/facility-redirect/:redirectId",
    component: FacilityRedirect,

  },
  {
    path: "/facility-redirect",
    component: FacilityRedirectAdd,

  },
  {
    path: "/proxies",
    component: Proxies,

  },
  {
    path: "/seo-texts",
    component: SeoTexts,

  },
  {
    path: "/seo-text/:id",
    component: SeoTextAdd,

  },
  {
    path: "/seo-text",
    component: SeoTextAdd,

  },
  {
    path: "/facility-texts",
    component: FacilityTexts,

  },
  {
    path: "/facility-text/:id",
    component: FacilityTextAdd,

  },
  {
    path: "/facility-text",
    component: FacilityTextAdd,

  },
  {
    path: "/crawlings",
    component: Crawlings,

  },
  {
    path: "/crawling/:crawlingId",
    component: Crawling,

  },
  {
    path: "/crawling/",
    component: CrawlingAdd,

  },
  {
    path: "/activities",
    component: Activities,

  },
  {
    path: "/activity/:activityId",
    component: Activity,

  },
  {
    path: "/subscription/:subscriptionId",
    component: Subscription,

  },
  {
    path: "/transactions",
    component: Transactions,

  },
  {
    path: "/transaction/:transactionId",
    component: Transaction,

  },
  {
    path: "/purchase/:purchaseId",
    component: Purchase,

  },
  {
    path: "/transaction-report",
    component: TransactionReport,

  },
  {
    path: "/sales-report-new",
    component: SalesReportNew,

  },
  {
    path: "/sales-report",
    component: SalesReport,

  },
  {
    path: "/sales-reports",
    component: SalesReports,

  },
  {
    path: "/reports", 
    component: Reports,

  },
  {
    path: "/marketing-consents",
    component: MarketingConsents,

  },
  {
    path: "/seasonal-court-report",
    component: SeasonalCourtReport,

  },
  {
    path: "/seasonalcourt/:seasonalCourtId",
    component: SeasonalCourt,

  },
  {
    path: "/seasonalcourtslot/:seasonalCourtSlotId",
    component: SeasonalCourtSlot,

  },
  {
    path: "/seasonal-courts",
    component: SeasonalCourts,

  },
  {
    path: "/seasonal-courts-overview",
    component: SeasonalCourtsOverview,

  },
  {
    path: "/developers",
    component: Developers,

  },
  {
    path: "/home",
    component: Home,

  },
  {
    path: "/seasonalcourtpurchases",
    component: SeasonalCourtPurchases,

  },
  {
    path: "/seasonalcourtpurchase/:seasonalCourtPurchaseId",
    component: SeasonalCourtPurchase,

  },
  {
    path: "/overview",
    component: Overview,

  },
  {
    path: "/confirmationEmail",
    component: ConfirmationEmails,

  },
  {
    path: "/email/:emailId",
    component: ConfirmationEmail,

  },
  {
    path: "/relayRule",
    component: RelayRules,

  },
  {
    path: "/locker",
    component: Lockers,

  },
  {
    path: "/locker/:lockerId",
    component: Locker,

  },
  {
    path: "/locker-create",
    component: LockerCreate,

  },
  {
    path: "/salto-master-codes",
    component: MasterCodes,

  },
  {
    path: "/provideradmin",
    component: ProviderAdmin,

  },
  {
    path: "/provideradmin/:providerAdminId",
    component: ProviderAdminDetails,

  }, 
  {
    path: "/externalpurchaseattempt/:attemptId",
    component: ExternalPurchaseAttempt,

  },
  {
    path: "/externalpurchase/:externalPurchaseId",
    component: ExternalPurchase,

  },
  {
    path: "/externalactivity/:externalActivityId",
    component: ExternalActivity,

  },
  {
    path: "/rule/:ruleId",
    component: RelayRule,

  },
  {
    path: "/checks",
    component: Checks,

  },
  {
    path: "/non-partner-facilities",
    component: NonPartnerFacilities,

  },
  {
    path: "/non-partner-facility/:id",
    component: NonPartnerFacility,

  },
  {
    path: "/play",
    component: Play,

  },
  {
    path: "/play/ambassador-applications",
    component: AmbassadorApplications,

  },
  {
    path: "/play/players",
    component: PlayPlayers,

  },
  {
    path: "/play/events",
    component: PlayEvents,
  },
  {
    path: "/play/events/:eventId",
    component: PlayEvent,
  },
  {
    path: "/play/events/:eventId/sessions/:sessionId",
    component: PlayEventSession,
  },
  {
    path: "/play/games",
    component: PlayGames,
  },
  {
    path: "/play/games/:code",
    component: PlayGame,
  },
  // Legacy redirect paths — kept so old bookmarks still work
  {
    path: "/ambassador-applications",
    component: AmbassadorApplications,

  },
  {
    path: "/play-players",
    component: PlayPlayers,

  },
  {
    path: "/clubhouses",
    component: ClubhouseAdminClubhouses,

  },
  {
    path: "/clubhouse/:slug",
    component: ClubhouseAdminClubhouse,

  },
  {
    path: "/clubhouse-wannas",
    component: ClubhouseAdminWannas,

  },
  {
    path: "/clubhouse-wanna/:code",
    component: ClubhouseAdminWanna,

  },
  {
    path: "/clubhouse-memberships",
    component: ClubhouseAdminMemberships,

  },
  {
    path: "/clubhouse-payments",
    component: ClubhouseAdminPayments,

  },
  {
    path: "/",
    component: Home,

  },

];
